/**
 * The single time zone the booking flow operates in.
 *
 * Every site this product serves is in one region, so appointment times are always expressed in
 * site local time rather than the visitor's own. Formatting with an explicit zone matters: an
 * applicant booking from outside the region would otherwise see their browser shift the
 * confirmation time away from the time the site actually expects them.
 *
 * Mirrors AmsTimeZone.Default on the server.
 */
export const BOOKING_TIME_ZONE = "America/Los_Angeles";
